import React from "react";
import { transformDate } from "../../../../../Utils/utils";

interface FirstCardRecalculateModalityProps {
  data: any;
  selectedModality: any;
  typeMoneyDescriptionList: any;
  conditionInvalidateList: any;
}

const FirstCardRecalculateModality = ({
  data,
  selectedModality,
  typeMoneyDescriptionList,
  conditionInvalidateList,
}: FirstCardRecalculateModalityProps) => {
  const gratificacion = selectedModality.gratificacion 
    || (data.modalidadGanada && data.modalidadGanada.datosModalidadGanada && data.modalidadGanada.datosModalidadGanada.gratificacion);
  
  const derechoCrecer = selectedModality.derechoCrecer 
    || (data.modalidadGanada && data.modalidadGanada.datosModalidadGanada && data.modalidadGanada.datosModalidadGanada.derechoCrecer);

  return (
    <div className="card-verify ">
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Número</div>
          <div className="card-verify__data">{data.nroOperacion}</div>
        </div>
        <div>
          <div className="card-verify__quote">Modalidad</div>
          <div className="card-verify__data">{selectedModality.modalidad}</div>
        </div>
        <div>
          <div className="card-verify__quote">Años Dif.:</div>
          <div className="card-verify__data">
            {selectedModality.anosRT || "--"}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Rel. Dif. %</div>
          <div className="card-verify__data">
            {selectedModality.porcentajeRVD || "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Años Garantizado</div>
          <div className="card-verify__data">
            {selectedModality.periodoGarantizado}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Moneda</div>
          <div className="card-verify__data">
            {typeMoneyDescriptionList[selectedModality.moneda]}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Gratificación</div>
          <div className="card-verify__data">
            {conditionInvalidateList[gratificacion] || "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Derecho a crecer</div>
          <div className="card-verify__data">
            {conditionInvalidateList[derechoCrecer] || "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Reajuste</div>
          <div className="card-verify__data">
            {selectedModality.reajuste || data.modalidadGanada.reajuste || "--"}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Número de mensualidad</div>
          <div className="card-verify__data">
            {selectedModality.numeroMensualidad ||
              data.numeroMensualidad ||
              "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Fecha devengue</div>
          <div className="card-verify__data">
            {transformDate(selectedModality.fechaDevengue) || transformDate(data.fechaDevengue) || "--"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstCardRecalculateModality;
